<template>
    <div>
        <MainHeader />
        <div class="page">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-7">
                        <div style="padding:20px;margin:40px 20px;background-color:#f6f6f6;border:1px solid #ccc;">
                            <h2 style="margin:10px 0px 20px 0px;">Log in with your Geofolio account</h2>
                            <form>
                              <div class="form-group">
                                <label for="exampleInputEmail1"  v-bind:class="{ 'is-invalid':error }">Email address</label>
                                <input ref="username" type="email" class="form-control"  v-bind:class="{ 'is-invalid':error }" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="">
                              </div>
                              <div class="form-group">
                                <label for="exampleInputPassword1"  v-bind:class="{ 'is-invalid':error }">Password</label>
                                <input ref="password" type="password" class="form-control" v-bind:class="{ 'is-invalid':error }" id="exampleInputPassword1" placeholder="">
                              </div>

                                <div v-if="error" class="is-invalid" style="padding-bottom:15px;">
                                    Authentication failed. Please check your credentials or get in touch via info@geofolio.org if you feel that an error has occurred.
                                </div>

                              <div class="row">
                                <div class="col text-center">
                                    <button type="submit" @click.prevent="logIn" class="btn btn-block btn-lg btn-primary"><strong>Login</strong></button>
                                </div>
                               </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
  import MainHeader from '@/components/generic/MainHeader.vue'
  import Footer from '@/components/generic/Footer.vue'

  export default {
    name: 'login',
    components: {
      MainHeader, Footer
    },
    data() {
        return {
            error: false
        }
    },
    computed: {
        count() {
            return this.$store.state.count
        },
        isValid() {
            if(this.error) {
                return "is-invalid"
            } else {
                return ""
            }
        }
    },
    methods: {
      logIn() {
        const params = {
           'username': this.$refs.username.value,
           'password': this.$refs.password.value
        }
        const headers = {
            'X-CSRFTOKEN': this.csrfcookie()
        }
        this.$axios
           .post(process.env.VUE_APP_API+"/api/login", params, { headers: headers })
           .then(response => {
                this.error = false;
                this.$store.commit('profile', response.data.profile)
                
           })
           .catch(error => {
                this.error = true
           })
      }
    }
  }
</script>

<style scoped>

div.page {
    font-size:1.1em;
    color:#666;
}
h1 {
    font-size:1.3em;
    font-weight:600;
    margin-top:15px;
}

h2 {
    font-size:1.2em;
    font-weight:600;
    margin-top:15px;
}

h3 {
    font-size:1.05em;
    font-weight:600;
    margin-top:15px;
}
p {
    line-height:1.4em;
}
.is-invalid {
    color: #dc3545;
}
label.is-invalid {
    font-weight:bold;
}
</style>